import React from 'react';
import { useTranslation } from 'react-i18next';
import {upperCaseFirstLetter} from '../../../../utils';
import Button from '../../../../components/button';

function MyProfileView (props) {

	const { t } = useTranslation();
	const {
		data,
		handleEdit
	} = props;

	return (
		<div className="col-10">
			<div className="row">
				<div className="col-12">
					<h2><strong>{data.name}</strong></h2>
					{
						data.details.job && data.details.company
						?
							<p><strong>{data.details.job} — {data.details.company}</strong></p>
						: data.details.company
							?
								<p><strong>{data.details.company}</strong></p>
							:
								data.details.job
								?
									<p><strong>{data.details.job}</strong></p>
								:
									'-'
					}
					{data.details.notes && <p className="description">{data.details.notes}</p>}
				</div>
			</div>
			<div className="mt-4 row">
				<div className="col-6">
					<h3>{t("myProfileContactInformation")}</h3>
					<p>{t("fieldJob")}: {data.details.job ? <strong>{data.details.job}</strong> : '-'}</p>
					<p>{t("fieldDepartment")}: {data.details.department ? <strong>{data.details.department}</strong> : '-'}</p>
					<p>{t("fieldCompany")}: {data.details.company ? <strong>{data.details.company}</strong> : '-'}</p>
					<p>{t("fieldEmail")}: {data.email ? <strong>{data.email}</strong> : '-'}</p>
					<div>
						<p>{t("fieldPhone")}:</p>
						{
							data.details.phoneNumbers && data.details.phoneNumbers.length > 0
							?
								<ul>
									{
										data.details.phoneNumbers.map((phoneNumber, index) => <li key={index}><strong>{phoneNumber.number}</strong> &bull; {upperCaseFirstLetter(phoneNumber.label)}</li>)
									}
								</ul>
							:
								'-'
						}
					</div>
				</div>
				<div className="col-6">
					<h3>{t("myProfileContactLocation")}</h3>
					<div>
						<p>{t("fieldPostalAddress")}:</p>
						{
							data.details.postalAddress && data.details.postalAddress.length > 0
								?
								<ul>
									{
										data.details.postalAddress.map((postalAddress, index) => <li key={index}><strong>{postalAddress.formattedAddress}</strong> &bull; {upperCaseFirstLetter(postalAddress.label)}</li>)
									}
								</ul>
								:
								'-'
						}
					</div>
					<p>Building: {data.details.building ? <strong>{data.details.building}</strong> : '-'}</p>
				</div>
			</div>
			<div className="text-right">
				<Button onClick={handleEdit} className="btn-primary">
					{t("textEditProfile")}
				</Button>
			</div>
		</div>
	)

}

export default MyProfileView;